import { type FC, type ReactNode } from 'react'
import { ariaDescribedByIds } from '@rjsf/utils'
import { usePreventWindowFileDrop } from '../../../../common/usePreventWindowFileDrop'
import { FileChip } from '../../../FileUpload/FileChip'
import { FileDropZone } from '../../../FileUpload/FileDropZone'
import styles from './MediaFileField.module.scss'

interface MediaFileFieldProps {
  id: string
  label: string
  disabled: boolean
  accept: string[]
  hint?: string
  file?: { name: string; size?: number }
  missing: boolean
  status?: ReactNode
  error?: string | null
  onFile: (file: File) => void
  onReject: (file: File) => void
  onRemove: () => void
}

export const MediaFileField: FC<MediaFileFieldProps> = ({ id, label, disabled, accept, hint, file, missing, status, error, onFile, onReject, onRemove }) => {
  const errorId = `${id}__file-error`

  usePreventWindowFileDrop()
  const describedBy = error ? `${ariaDescribedByIds(id)} ${errorId}` : ariaDescribedByIds(id)

  return (
    <div className={styles.field}>
      {status ??
        (file ? (
          <FileChip fileName={file.name} fileSize={file.size} disabled={disabled} ariaDescribedBy={describedBy} onRemove={onRemove} />
        ) : (
          <FileDropZone
            id={id}
            label={label}
            hint={hint}
            ariaDescribedBy={describedBy}
            unavailable={missing}
            disabled={disabled}
            accept={accept}
            onFile={onFile}
            onReject={onReject}
          />
        ))}
      {error ? (
        <div id={errorId} role='alert' className='paragraph-small text-danger mt-1'>
          {error}
        </div>
      ) : null}
    </div>
  )
}
